module.exports = __webpack_public_path__ + "static/media/Major_Assemblies_icon.9015b027.svg";